import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            gap: {base: 'xxsmall.md', md: 'xsmall.md'},
            alignItems: 'center',
            marginTop: remCalc(36),
            marginBottom: {md: remCalc(17)},
        },
        title: {
            color: 'text.primary',
            textStyle: 'head-small',
            fontWeight: 'medium',
        },
        quantity: {
            textStyle: 'head-small',
            fontWeight: 'bold',
            color: 'text.secondary',
        },
        editorialComponentsContainer: {},
        searchTitle: {
            textStyle: 'display-large',
            color: 'foreground.neutral.default',
            fontWeight: 'light',
            gap: 'xxsmall.base',
        },
        searchSubtitle: {
            textStyle: 'body-medium',
            color: 'text.secondary',
            fontWeight: 'normal',
            gap: 'xxsmall.base',
        },
        searchContainer: {
            gap: {base: 'medium.base', lg: 'medium.lg'},
            marginBottom: ['small.base', 'small.md', 'small.lg', 'small.xl'],
            paddingTop: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        searchContainerTitles: {
            gap: {
                base: 'xsmall-1.lg',
                sm: 'xsmall-1.lg',
                md: 'xxsmall-1.base',
                lg: 'xxsmall-1.base',
            },
        },
        searchResultsLabel: {
            color: 'foreground.neutral.subtle',
            textStyle: 'body-xsmall',
        },
        searchContainerButtons: {
            gap: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.subtle',
            marginBottom: ['small.base', 'small.md', 'small.lg', 'small.xl'],
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            whiteSpace: 'nowrap',
            overflowX: 'auto',
        },
        searchSectionButton: {
            //?Removing this margin will add a -2 margin to the button and pretty much remove the border on select
            marginBottom: 0,
            py: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            px: 0,
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.muted',
            _focus: {
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'foreground.accent.default',
                color: 'foreground.accent.default',
                backgroundColor: 'transparent',
            },
            _selected: {
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'foreground.accent.default',
                color: 'foreground.accent.default',
                backgroundColor: 'transparent',
            },
            _active: {backgroundColor: 'transparent'},
        },
        searchSectionButtonContent: {
            display: 'flex',
            alignItems: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.sm', 'xxxsmall-1.md', 'xxxsmall-1.lg'],
        },
        searchSectionButtonCount: {
            color: 'foreground.neutral.subtle',
            fontWeight: 'medium',
            textStyle: 'body-xsmall',
            lineHeight: 'normal',
        },
        pageHeaderContainer: {
            width: '100%',
            maxW: remCalc(600),
            marginTop: 'xsmall-1.base',
            marginBottom: {
                base: remCalc(20),
                sm: remCalc(20),
                md: 'medium.base',
                lg: 'medium.base',
            },
        },
        pageHeaderColumn: {
            flexDir: 'column',
            gap: 'xxsmall-1.base',
        },
        categoryTitleBox: {
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
        },
        categoryTitleText: {
            textStyle: 'display-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
        },
        heroBannerBox: {
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
        },
        heroBannerText: {
            textStyle: 'body-xxlarge',
            fontWeight: 'light',
            color: 'foreground.neutral.muted',
            lineHeight: '1.65rem',
        },
        loadingSpinnerWrapper: {
            position: 'absolute',
            top: 0,
            right: 'auto',
            bottom: 'auto',
            left: 0,
            background: 'transparent',
            width: 0,
            height: 0,
            overflow: 'visible',
        },
        loadingSpinnerStyles: {
            position: 'absolute',
            top: 0,
            left: 0,
            ml: 0,
            mt: 0,
            size: 'sm',
            thickness: '2px',
            color: 'foreground.neutral.subtle',
        },
    },
}
